module.exports = __webpack_public_path__ + "4909048b66f69de9984d28933fbb10ab.png";